import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  CssBaseline,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Snackbar,
  SnackbarContent,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import AdminNavigation from "./adminNavigation";
import LiqueModal from "../customer/components/liqueModal";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TrashIcon from "../assets/icon/TrashIcon";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { btnStyleContrast, btnStyleOutlined, lightergrayHex, subHeaderStyleContrast, textStyleContrast } from "../helper/style";
import { NumericFormat } from "react-number-format";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PartnerService from "../services/manager/partnerService";
import noImage from "../assets/no-image.png";
import { useDropzone } from "react-dropzone";
import { set } from "date-fns";
import { AddressService } from "../services/customer/addressService";

const imageUrl = process.env.REACT_APP_IMAGE_URL

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewPartner() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [errors, setErrors] = useState({});
  const [showMsgImage, setShowMsgImage] = useState(false);
  const [msgImageError, setMsgImageError] = useState("");

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);

  const [listPartner, setListPartner] = useState([]);
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [cpNumber, setCpNumber] = useState(null);
  const [name, setName] = useState(null);
  const [picName, setPicName] = useState(null);
  const [password, setPassword] = useState(null);
  const [reTypePassword, setReTypePassword] = useState(null);
  const [logo, setLogo] = useState(null);
  const [logoMultipart, setLogoMultipart] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showReTypePassword, setShowReTypePassword] = useState(false);
  const [bankName, setBankName] = useState(null);
  const [bankAccountNo, setBankAccountNo] = useState(null);
  const [bankAccountName, setBankAccountName] = useState(null);
  const [address, setAddress] = useState(null);
  const [province, setProvince] = useState(null);
  const [city, setCity] = useState(null);
  const [district, setDistrict] = useState(null);
  const [subDistrict, setSubDistrict] = useState(null);
  const [zipcode, setZipcode] = useState(null);

  const [selectedPartner, setSelectedPartner] = useState(null);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  
  const [loading, setLoading] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);

  const activateSuccess = (msg) => {
    setmsgSuccess(msg);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = (msg) => {
    setMsgError(msg)
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const clearFields = () => {
    setUsername(null);
    setEmail(null);
    setPhoneNumber(null);
    setName(null);
    setPicName(null);
    setPassword(null);
    setReTypePassword(null);
    setLogo(null);
    setLogoMultipart(null);
    setShowMsgImage(false);
    setMsgImageError("");
    setSelectedPartner(null);
    setShowPassword(false);
    setShowReTypePassword(false);
    setBankName(null);
    setBankAccountName(null);
    setBankAccountNo(null);
    setAddress(null);
    setProvince(null);
    setCity(null);
    setDistrict(null);
    setSubDistrict(null);
    setZipcode(null);
    setCpNumber(null);
    setErrors({});
  }

  const handleOpenAdd = () => {
    setOpenAdd(true);
  }

  const handleCloseAdd = () => {
    setOpenAdd(false);
    clearFields();
  }

  const handleOpenEdit = (partner) => {
    setSelectedPartner(partner);
    setUsername(partner.username);
    setEmail(partner.email);
    setPhoneNumber(partner.phonenumber);
    setName(partner.name);
    setPicName(partner.picName);
    setLogo(partner.logo);
    setBankName(partner.bankName);
    setBankAccountNo(partner.bankAccountNo);
    setBankAccountName(partner.bankAccountName);
    setAddress(partner.address);
    setCpNumber(partner.cpNumber);

    fetchCities(partner.province);
    fetchDistricts(partner.province, partner.city);
    fetchSubDistricts(partner.province, partner.city, partner.district);
    fetchZipCode(partner.province, partner.city, partner.district, partner.subDistrict);

    setProvince(partner.province);
    setCity(partner.city);
    setDistrict(partner.district);
    setSubDistrict(partner.subDistrict);
    setZipcode(partner.zipCode);

    setOpenEdit(true);
  }

  const handleCloseEdit = () => {
    setOpenEdit(false);
    clearFields();
  }

  const handleOpenDelete = (partner) => {
    setSelectedPartner(partner);
    setOpenDelete(true);
  }

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedPartner(null);
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      // Only accept the first valid image file
      const validFile = acceptedFiles.find((file) =>
        /\.(jpg|jpeg|png)$/i.test(file.name)
      );
      if (validFile) {
        setShowMsgImage(false);

        const reader = new FileReader();
        reader.readAsDataURL(validFile);
        reader.onload = () => {
          setLogoMultipart({
            path: validFile.name,
            preview: reader.result,
            originalFile: validFile,
          });
        };
      } else {
        setShowMsgImage(true);
        setMsgImageError(
          "Invalid file type detected. Please upload only one image file."
        );
      }
    },
    [setLogoMultipart]
  );
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/jpg': [],
      'image/gif': [],
    },
  });

  const getListPartner = async () => {
    try {
      const response = await PartnerService.getListPartner(page, perPage, search);
      if (response) {
        const data = response.data;
        setListPartner(data.partnerList);
        setTotalItem(data.totalItem);
        setTotalPage(data.totalPage);
      }
    } catch (error) {
      console.error("Error fetching partner list:", error);
      activateError("Gagal mendapatkan data mitra");
    }
  }

  const validate = (type = "add") => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let tempErrors = {};

    if (!username) {
      tempErrors.username = "Username harus diisi";
    } else if (username.length > 50) {
      tempErrors.username = "Username maksimal berjumlah 50 karakter";
    }

    if (!email) {
      tempErrors.email = "Email harus diisi";
    } else if (email.length > 255) {
      tempErrors.email = "Email barang maksimal berjumlah 255 karakter";
    } else if (!emailRegex.test(email)) {
      tempErrors.email = "Email tidak valid";
    }

    if (!phoneNumber) {
      tempErrors.phoneNumber = "Nomor telepon harus diisi";
    } else if (phoneNumber.length < 10 || phoneNumber.length > 12) {
      tempErrors.phoneNumber = "Nomor telepon harus berjumlah antara 10-12 digit";
    }

    if (!name) {
      tempErrors.name = "Nama mitra harus diisi";
    }

    if (!picName) {
      tempErrors.picName = "Nama PIC harus diisi";
    }

    if (!bankName) {
      tempErrors.bankName = "Nama bank mitra harus diisi";
    } else if (bankName.length > 100) {
      tempErrors.bankName = "Nama bank mitra maksimal berjumlah 100 karakter";
    }

    if (!bankAccountNo) {
      tempErrors.bankAccountNo = "Nomor rekening mitra harus diisi";
    } else if (bankAccountNo.length > 100) {
      tempErrors.bankAccountNo = "Nomor rekening mitra maksimal berjumlah 100 karakter";
    }

    if (!bankAccountName) {
      tempErrors.bankAccountName = "Nama rekening mitra harus diisi";
    } else if (bankAccountName.length > 100) {
      tempErrors.bankAccountName = "Nama rekening mitra maksimal berjumlah 100 karakter";
    }

    if (type === "add") {
      if (!password) {
        tempErrors.password = "Password harus diisi";
      } else if (password.length < 8) {
        tempErrors.password = "Password minimal 8 karakter";
      } else if (password.length > 50) {
        tempErrors.password = "Password maksimal 50 karakter";
      }

      if (!reTypePassword) {
        tempErrors.reTypePassword = "Konfirmasi password harus diisi";
      } else if (reTypePassword !== password) {
        tempErrors.reTypePassword = "Konfirmasi password tidak sesuai";
      }
    }

    if (!address) {
      tempErrors.address = "Alamat mitra harus diisi";
    }

    if (!province) {
      tempErrors.province = "Provinsi harus diisi";
    }

    if (!city) {
      tempErrors.city = "Kabupaten / Kota harus diisi";
    }

    if (!district) {
      tempErrors.district = "Kecamatan harus diisi";
    }

    if (!subDistrict) {
      tempErrors.subDistrict = "Desa / Kelurahan harus diisi";
    }

    if (!zipcode) {
      tempErrors.zipcode = "Kode pos harus diisi";
    }
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const validatePassword = () => {
    let tempErrors = {};

    if (!password) {
      tempErrors.password = "Password harus diisi";
    } else if (password.length < 8) {
      tempErrors.password = "Password minimal 8 karakter";
    } else if (password.length > 50) {
      tempErrors.password = "Password maksimal 50 karakter";
    }

    if (!reTypePassword) {
      tempErrors.reTypePassword = "Konfirmasi password harus diisi";
    } else if (reTypePassword !== password) {
      tempErrors.reTypePassword = "Konfirmasi password tidak sesuai";
    }
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const fetchProvinces = async () => {
    try {
      const response = await AddressService.fetchProfinces();
      if (response) {
        setProvinces(response.data.provinceList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchCities = async (provinceId) => {
    try {
      const response = await AddressService.fetchCities(provinceId);
      if (response) {
        setCities(response.data.districtList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchDistricts = async (provinceId, cityId) => {
    try {
      const response = await AddressService.fetchSubDistricts(provinceId, cityId);
      if (response) {
        setDistricts(response.data.subdistrictList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchSubDistricts = async (provinceId, cityId, subDistrictId) => {
    try {
      const response = await AddressService.fetchNeighborhoods(provinceId, cityId, subDistrictId);
      if (response) {
        setSubDistricts(response.data.neighborhoodList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const fetchZipCode = async (provinceId, cityId, subDistrictId, neighborhood) => {
    try {
      const response = await AddressService.fetchZipCode(provinceId, cityId, subDistrictId, neighborhood);
      if (response) {
        setZipcodes(response.data.zipCodeList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const addPartner = async () => {
    if (!validate("add")) return;

    setLoading(true);
    try {
      const response = await PartnerService.addPartner(
        username,
        email,
        phoneNumber,
        name,
        picName,
        password,
        reTypePassword,
        logoMultipart,
        bankName,
        bankAccountNo,
        bankAccountName,
        address,
        province,
        city,
        district,
        subDistrict,
        zipcode,
        cpNumber
      );

      if (response) {
        getListPartner();
        activateSuccess("Berhasil menambah mitra");
        handleCloseAdd();
      }
    } catch (error) {
      if (error.response.status === 400) {
        activateError(error.response.data?.message);
      } else {
        activateError("Gagal menambah mitra");
      }
      console.error("Error adding partner:", error);
    } finally {
      setLoading(false);
    }
  }

  const updatePartner = async () => {
    if (!validate("update")) return;
    
    setLoading(true);
    try {
      const response = await PartnerService.updatePartner(
        selectedPartner.id,
        username,
        email,
        phoneNumber,
        name,
        picName,
        logoMultipart,
        bankName,
        bankAccountNo,
        bankAccountName,
        address,
        province,
        city,
        district,
        subDistrict,
        zipcode,
        cpNumber
      );

      if (response) {
        getListPartner();
        activateSuccess("Berhasil mengubah mitra");
        handleCloseEdit();
      }
    } catch (error) {
      if (error.response.status === 400) {
        activateError(error.response.data?.message);
      } else {
        activateError("Gagal mengubah mitra");
      }
      console.error("Error updating partner:", error);
    } finally {
      setLoading(false);
    }
  }

  const deletePartner = async () => {
    setLoading(true);
    try {
      const response = await PartnerService.deletePartner(selectedPartner.id);
      if (response) {
        getListPartner();
        activateSuccess("Berhasil menghapus mitra");
        handleCloseDelete();
      }
    } catch (error) {
      if (error.response.status === 400) {
        activateError(error.response.data?.message);
      } else {
        activateError("Gagal menghapus mitra");
      }
      console.error("Error deleting partner:", error);
    } finally {
      setLoading(false);
    }
  }

  const updatePartnerPassword = async () => {
    if (!validatePassword()) return;

    setLoadingPassword(true);
    try {
      const response = await PartnerService.updatePartnerPassword(
        selectedPartner.id,
        password,
        reTypePassword
      );

      if (response) {
        getListPartner();
        activateSuccess("Berhasil mengubah password mitra");
        handleCloseEdit();
      }
    } catch (error) {
      if (error.response.status === 400) {
        activateError(error.response.data?.message);
      } else {
        activateError("Gagal mengubah password mitra");
      }
      console.error("Error updating partner:", error);
    } finally {
      setLoadingPassword(false);
    }
  }

  useEffect(() => {
    getListPartner();
    fetchProvinces();
  }, []);
  
  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      getListPartner();
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search]);
  
  useEffect(() => {
    getListPartner();
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" marginBottom={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...subHeaderStyleContrast }}>
                Kelola Mitra
              </Typography>
            </Grid>
            <Grid item xs={6} sm={8} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari Mitra..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Button 
                endIcon={<AddIcon sx={{ color: "white" }} />}
                style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }}
                onClick={handleOpenAdd}
              >
                Tambah Mitra
              </Button>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px", width: "100%" }} marginBottom={3}>
            {
              listPartner.map(partner => (
                <Box  
                  key={partner.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" gap="20px" alignItems="center">
                      <Typography sx={{ ...textStyleContrast, color: lightergrayHex }} display="flex" alignItems="center" gap="10px">
                        <CalendarTodayOutlinedIcon /> <span>Last Update: {partner.lastUpdate}</span>
                      </Typography>
                    </Grid>
                    <Grid item xs={4} md={1}>
                      <Box sx={{ width: "100%" }}>
                        <img
                          src={
                            !partner.logo
                            ? noImage
                            : `${imageUrl}${partner.logo}`
                          }
                          alt={`Logo ${partner.name}`}
                          style={{
                            width: "100%",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            marginRight: "3%",
                            borderRadius: "8px"
                          }}
                        ></img>
                      </Box>
                    </Grid>
                    <Grid item xs={8} md={5}>
                      <Typography sx={{ ...subHeaderStyleContrast, fontWeight: "500" }}>
                        {partner.name}
                      </Typography>
                      <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                        Mitra bergabung {partner.createdDate}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} display="flex" justifyContent="end" alignItems="end" gap="10px">
                      <Button 
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "120px" }}
                        endIcon={<EditOutlinedIcon />}
                        onClick={() => handleOpenEdit(partner)}
                      >
                        Edit
                      </Button>
                      <Button 
                        sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "120px", color: "red", border: "1px solid red" }}
                        endIcon={<TrashIcon color="red" />}
                        onClick={() => handleOpenDelete(partner)}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))
            }

            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>
          </Box>
        </RootContainer>
      </Container>

      <LiqueModal open={openAdd} onClose={handleCloseAdd} width="1200px">
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography>Logo Mitra *</Typography>
              <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                Upload logo mitra dalam format JPG, JPEG, PNG. Maksimal 4MB.
              </Typography>
              <Box
                {...getRootProps()}
                marginTop={1}
                sx={{
                  border: "2px solid #aaa",
                  borderRadius: "14px",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                  transition: "background-color 0.2s",
                  width: "150px",
                  height: "150px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <Typography>Letakkan file disini</Typography>
                ) : (
                  <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                    <AddIcon sx={{ margin: "auto" }} />
                    <Typography>Tambah Foto</Typography>
                  </Box>
                )}
              </Box>
              {!showMsgImage && logoMultipart && (
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Box mb={2} mr={2}>
                    <Typography>{logoMultipart.path}</Typography>
                    <img
                      src={logoMultipart.preview}
                      alt={logoMultipart.path}
                      style={{ maxWidth: "70%", maxHeight: "100px" }}
                    />
                  </Box>
                </Box>
              )}
              {showMsgImage && (
                <Typography sx={{ color: "red" }}>
                  {msgImageError}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={name}
                error={!!errors.name}
                helperText={errors.name}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Username *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={username}
                error={!!errors.username}
                helperText={errors.username}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama PIC Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={picName}
                error={!!errors.picName}
                helperText={errors.picName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPicName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nomor HP Mitra *</Typography>
              <NumericFormat
                customInput={TextField}
                fullWidth
                autoComplete="off"
                value={phoneNumber}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Email *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={email}
                error={!!errors.email}
                helperText={errors.email}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Contact Person Pengiriman</Typography>
              <NumericFormat
                customInput={TextField}
                fullWidth
                autoComplete="off"
                value={cpNumber}
                error={!!errors.cpNumber}
                helperText={errors.cpNumber}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setCpNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama Bank Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankName}
                error={!!errors.bankName}
                helperText={errors.bankName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>No. Rekening Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankAccountNo}
                error={!!errors.bankAccountNo}
                helperText={errors.bankAccountNo}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankAccountNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Nama Rekening Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankAccountName}
                error={!!errors.bankAccountName}
                helperText={errors.bankAccountName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankAccountName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Alamat Mitra *</Typography>
              <TextareaAutosize
                style={{ width: "100%" }}
                minRows={3}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              {!!errors.address ? (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.address}
                </FormHelperText>
              ) : null}
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Provinsi *</Typography>
              <Autocomplete
                options={provinces} 
                getOptionLabel={(option) => option} 
                value={province}
                onChange={(event, newValue) => {
                  setCity(null);
                  setDistrict(null);
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchCities(newValue);
                  setProvince(newValue);
                }}
                helperText={errors.province}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kabupaten / Kota *</Typography>
              <Autocomplete
                options={cities}
                getOptionLabel={(option) => option}
                value={city}
                onChange={(event, newValue) => {
                  setDistrict(null);
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchDistricts(province, newValue);
                  setCity(newValue);
                }}
                helperText={errors.city}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={province === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kecamatan *</Typography>
              <Autocomplete
                options={districts} 
                getOptionLabel={(option) => option} 
                value={district}
                onChange={(event, newValue) => {
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchSubDistricts(province, city, newValue);
                  setDistrict(newValue);
                }}
                helperText={errors.district}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={city === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Desa / Kelurahan *</Typography>
              <Autocomplete
                options={subDistricts}
                getOptionLabel={(option) => option}
                value={subDistrict}
                onChange={(event, newValue) =>{
                  setZipcode(null);

                  setSubDistrict(newValue)
                  fetchZipCode(province, city, district, newValue)
                }}
                helperText={errors.subDistrict}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={district === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kode Pos *</Typography>
              <Autocomplete
                options={zipcodes}
                getOptionLabel={(option) => option}
                value={zipcode}
                onChange={(event, newValue) =>
                  setZipcode(newValue)
                }
                helperText={errors.zipcode}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={subDistrict === null}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Password *</Typography>
              <TextField
                type={showPassword ? "text" : "password"}
                value={password}
                fullWidth
                helperText={errors.password}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer", marginTop: "3px" }}
                      >
                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Konfirmasi Password *</Typography>
              <TextField
                type={showReTypePassword ? "text" : "password"}
                value={reTypePassword}
                fullWidth
                helperText={errors.reTypePassword}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setReTypePassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        onClick={() => setShowReTypePassword(!showReTypePassword)}
                        style={{ cursor: "pointer", marginTop: "3px" }}
                      >
                        { showReTypePassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={addPartner}
                fullWidth
                style={{ backgroundColor: "black", color: "white" }}
                disabled={loading}
              >
                {loading ? 'Mohon menunggu...' : 'Tambah Mitra'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </LiqueModal>

      <LiqueModal open={openEdit} onClose={handleCloseEdit} width="1200px">
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography>Logo Mitra *</Typography>
              <Typography sx={{ ...textStyleContrast, color: lightergrayHex }}>
                Upload logo mitra dalam format JPG, JPEG, PNG. Maksimal 4MB.
              </Typography>
              <Box
                {...getRootProps()}
                marginTop={1}
                sx={{
                  border: "2px solid #aaa",
                  borderRadius: "14px",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                  transition: "background-color 0.2s",
                  width: "150px",
                  height: "150px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <Typography>Letakkan file disini</Typography>
                ) : (
                  <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                    <AddIcon sx={{ margin: "auto" }} />
                    <Typography>Tambah Foto</Typography>
                  </Box>
                )}
              </Box>
              {!showMsgImage && logoMultipart && (
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <Box mb={2} mr={2}>
                    <Typography>{logoMultipart.path}</Typography>
                    <img
                      src={logoMultipart.preview}
                      alt={logoMultipart.path}
                      style={{ maxWidth: "70%", maxHeight: "100px" }}
                    />
                  </Box>
                </Box>
              )}
              {showMsgImage && (
                <Typography sx={{ color: "red" }}>
                  {msgImageError}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={name}
                error={!!errors.name}
                helperText={errors.name}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Username *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={username}
                error={!!errors.username}
                helperText={errors.username}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama PIC Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={picName}
                error={!!errors.picName}
                helperText={errors.picName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPicName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nomor HP Mitra *</Typography>
              <NumericFormat
                customInput={TextField}
                fullWidth
                autoComplete="off"
                value={phoneNumber}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Email *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={email}
                error={!!errors.email}
                helperText={errors.email}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Contact Person Pengiriman</Typography>
              <NumericFormat
                customInput={TextField}
                fullWidth
                autoComplete="off"
                value={cpNumber}
                error={!!errors.cpNumber}
                helperText={errors.cpNumber}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setCpNumber(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Nama Bank Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankName}
                error={!!errors.bankName}
                helperText={errors.bankName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>No. Rekening Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankAccountNo}
                error={!!errors.bankAccountNo}
                helperText={errors.bankAccountNo}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankAccountNo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Nama Rekening Mitra *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={bankAccountName}
                error={!!errors.bankAccountName}
                helperText={errors.bankAccountName}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setBankAccountName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Alamat Mitra *</Typography>
              <TextareaAutosize
                style={{ width: "100%" }}
                minRows={3}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              {!!errors.address ? (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.address}
                </FormHelperText>
              ) : null}
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Provinsi *</Typography>
              <Autocomplete
                options={provinces} 
                getOptionLabel={(option) => option} 
                value={province}
                onChange={(event, newValue) => {
                  setCity(null);
                  setDistrict(null);
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchCities(newValue);
                  setProvince(newValue);
                }}
                helperText={errors.province}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kabupaten / Kota *</Typography>
              <Autocomplete
                options={cities}
                getOptionLabel={(option) => option}
                value={city}
                onChange={(event, newValue) => {
                  setDistrict(null);
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchDistricts(province, newValue);
                  setCity(newValue);
                }}
                helperText={errors.city}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={province === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kecamatan *</Typography>
              <Autocomplete
                options={districts} 
                getOptionLabel={(option) => option} 
                value={district}
                onChange={(event, newValue) => {
                  setSubDistrict(null);
                  setZipcode(null);

                  fetchSubDistricts(province, city, newValue);
                  setDistrict(newValue);
                }}
                helperText={errors.district}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={city === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Desa / Kelurahan *</Typography>
              <Autocomplete
                options={subDistricts}
                getOptionLabel={(option) => option}
                value={subDistrict}
                onChange={(event, newValue) =>{
                  setZipcode(null);
                  
                  setSubDistrict(newValue)
                  fetchZipCode(province, city, district, newValue)
                }}
                helperText={errors.subDistrict}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={district === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography>Kode Pos *</Typography>
              <Autocomplete
                options={zipcodes}
                getOptionLabel={(option) => option}
                value={zipcode}
                onChange={(event, newValue) =>
                  setZipcode(newValue)
                }
                helperText={errors.zipcode}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                  />
                )}
                disabled={subDistrict === null}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={updatePartner}
                fullWidth
                style={{ backgroundColor: "black", color: "white" }}
                disabled={loading}
              >
                {loading ? 'Mohon menunggu...' : 'Ubah Mitra'}
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={3} marginTop={2}>
            <Grid item xs={12}>
              <Typography>Password *</Typography>
              <TextField
                type={showPassword ? "text" : "password"}
                value={password}
                fullWidth
                helperText={errors.password}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer", marginTop: "3px" }}
                      >
                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Konfirmasi Password *</Typography>
              <TextField
                type={showReTypePassword ? "text" : "password"}
                value={reTypePassword}
                fullWidth
                helperText={errors.reTypePassword}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setReTypePassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <div
                        onClick={() => setShowReTypePassword(!showReTypePassword)}
                        style={{ cursor: "pointer", marginTop: "3px" }}
                      >
                        { showReTypePassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={updatePartnerPassword}
                fullWidth
                style={{ backgroundColor: "black", color: "white" }}
                disabled={loadingPassword}
              >
                {loadingPassword ? 'Mohon menunggu...' : 'Ubah Password'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </LiqueModal>

      <LiqueModal open={openDelete} onClose={handleCloseDelete} width="600px">
        <Box textAlign="center">
          <Typography id="spring-modal-title" variant="h6" component="h2">
            Apakah kamu yakin ingin membuang data ini?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={handleCloseDelete}>
              Batal
            </Button>
            <Button
              variant="outlined"
              onClick={deletePartner}
              sx={{ ml: 2, backgroundColor: "red", color: "white" }}
              disabled={loading}
            >
              {loading ? 'Mohon menunggu...' : 'Buang'}
            </Button>
          </Box>
        </Box>
      </LiqueModal>
    </Box>
  )
}